<template>
	<div class="checkout-address-selector mb-10">
		<div class="ux-radio-list is-horz mb-6">
			<ux-radio v-if="paymentMethodList.length > 0" label="Existing method" :data="false" :value="addNew" @input="setNewMethod(false)" />
			<ux-radio label="New method" :data="true" :value="addNew" @input="setNewMethod(true)" />
		</div>

		<template v-if="addNew">
			<method-form ref="methodForm" :method.sync="newMethod" />
		</template>

		<template v-else>
			<div class="row">
				<div v-for="method in paymentMethodList" :key="method.id" class="col-md-6">
					<method-option :method="method" :selected="selected" @update:selected="changeMethod($event)" />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import MethodForm from 'frontend/payment-methods/comp/PaymentMethodForm.vue';
//import { defaultAddr } from 'frontend/addresses/info';

import MethodOption from './MethodOption.vue';

const defaultMethod = {
	id: 0,
	name: '',
	is_primary: false,
	billing_addr: {},
}

export default {
	components: { MethodForm, MethodOption },

	data()
	{
		return {
			addNew: false,
			selected: '',
			//newAddress: { ...defaultAddr },
		}
	},

	computed: {
		...mapGetters('paymentMethods', ['paymentMethodList']),
		...mapState({
			methods: state => state.paymentMethods.methods,
			order: state => state.checkout.order,
		}),

		selectedMethod()
		{
			return this.methods[this.selected];
		},

		newMethod: {
			get()
			{
				return this.order.paymentMethod;
			},

			set(method)
			{
				if (this.addNew)
					this.updateOrder({ paymentMethod: { ...method, is_new: true } });
			}
		}
	},

	methods: {
		...mapMutations('checkout', ['updateOrder']),

		// get primary method
		getPrimaryMethod()
		{
			var primary = this.paymentMethodList.find(a => a.is_primary);
			return primary || this.paymentMethodList[0];
		},

		// change between existing methods
		changeMethod(id)
		{
			var method = this.methods[id];

			// if address is valid then load it into the order state
			if (method)
			{
				this.selected = id;
				this.updateOrder({ paymentMethod: { ...method } });
			}
		},

		// select the primary method
		selectPrimaryMethod()
		{
			var primary = this.getPrimaryMethod();
			
			// if found then change address
			if (primary)
			{
				this.changeMethod(primary.id);
			}
			// otherwise clear selection
			else
			{
				this.updateOrder({ paymentMethod: {} });
				this.selected = '';
			}
		},

		// toggle between adding a new address or selecting an existing one
		setNewMethod(flag)
		{
			this.addNew = flag;

			// if entering a new address then load a blank address into order state
			if (flag)
				this.newMethod = { ...defaultMethod, id: 0 };
			// otherwise select the primary shipping/billing address
			else if (this.paymentMethodList.length > 0)
				this.selectPrimaryMethod();
		},

		getNonce()
		{
			return this.$refs.methodForm.getNonce();
		}
	},

	mounted()
	{
		if (this.paymentMethodList.length > 0)
			this.selectPrimaryMethod();
		else
			this.setNewMethod(true);
	}
}
</script>